/* INTENZE · Find Your Palette — skin-tone finder engine
   assets/skin-tone-finder.js  ·  rebuilt 2026-08-16

   Reads #finder-data (handle/name/hex/opacity, 112 colours) and #finder-tones,
   renders into #finder-mount, resolves live variants + prices from the storefront
   JSON endpoints, and quick-adds to the Sense cart drawer.

   Swatches render IMMEDIATELY from the inline palette — they never wait on the
   network. Prices and size pills fill in a moment later.

   Pigment-under-skin veil model. Fitzpatrick-aligned tone stops.
*/
(function () {
  var mount = document.getElementById('finder-mount');
  if (!mount) return;
  var section = mount.closest('[data-finder]') || document;
  var SHIP_GOAL = parseFloat(section.getAttribute('data-ship-goal')) || 150;
  var showPreview = section.getAttribute('data-show-preview-tones') !== 'false';
  var SOURCE = section.getAttribute('data-source') || 'color-tattoo-ink';

  var RAW, TONES;
  try { RAW = JSON.parse(document.getElementById('finder-data').textContent); }
  catch (e) { RAW = []; }
  try { TONES = JSON.parse(document.getElementById('finder-tones').textContent); }
  catch (e) { TONES = []; }

  // normalise: the inline blob uses slim keys (h/n/x/o/e); a shop-metafield
  // palette may use full keys. Accept either.
  var INKS = (RAW || []).map(function (c) {
    return {
      handle: c.h || c.handle,
      name: c.n || c.name,
      hex: (c.x || c.hex || '#CCCCCC').toUpperCase(),
      opacity: typeof (c.o !== undefined ? c.o : c.opacity) === 'number' ? (c.o !== undefined ? c.o : c.opacity) : 0.52,
      est: !!(c.e || c.est),
      url: '/products/' + (c.h || c.handle),
      variants: null
    };
  }).filter(function (k) { return k.handle && k.hex; });

  TONES = TONES.filter(function (t) { return showPreview || !t.preview; });
  TONES.unshift({ key: 'none', name: 'No filter', skin: '#F4ECE0', depth: 0, fst: '', wl: 0, preview: true });

  if (!INKS.length || TONES.length < 2) {
    mount.innerHTML = '<p style="color:#6B7280">Finder data unavailable.</p>';
    return;
  }

  /* ---- colour model (unchanged from the verified build) ---- */
  function hx(h){h=h.replace('#','');return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)];}
  function toHex(a){return '#'+a.map(function(v){return Math.round(Math.max(0,Math.min(255,v))).toString(16).padStart(2,'0');}).join('');}
  function mix(a,b,t){return a.map(function(v,i){return v+(b[i]-v)*t;});}
  function lum(hex){var c=hx(hex);return (0.2126*c[0]+0.7152*c[1]+0.0722*c[2])/255;}
  function veil(o,d){return Math.max(0,Math.min(0.94,d*(1.18-0.62*o)));}
  function wloss(o,hex,t){return (lum(hex)>0.82&&o>0.85)?(t.wl||0):0;}
  function observed(hex,o,t){var c=mix(hx(hex),hx(t.skin),veil(o,t.depth));var wl=wloss(o,hex,t);if(wl>0)c=mix(c,hx(t.skin),wl);return toHex(c);}
  function survival(o,t){return 1-veil(o,t.depth)*0.85;}
  function perf(ink,t){var wl=wloss(ink.opacity,ink.hex,t);return (ink.vivid||0.7)*survival(ink.opacity,t)*(1-wl*0.8);}
  function money(n){return (n===null||n===undefined)?'—':'$'+Number(n).toFixed(2);}

  /* ---- live variant + price resolution ---- */
  // collection JSON gives price as a decimal STRING ("9.66");
  // /products/<handle>.js gives price in integer CENTS (966). Normalise both.
  function fromCollectionJson(k, p) {
    k.url = '/products/' + p.handle;
    k.variants = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, price: parseFloat(v.price), available: v.available !== false };
    });
  }
  function fromProductJs(k, p) {
    k.url = '/products/' + p.handle;
    k.variants = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, price: Number(v.price) / 100, available: v.available !== false };
    });
  }
  function resolveVariants() {
    return fetch('/collections/' + SOURCE + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var map = {};
        (d.products || []).forEach(function (p) { map[p.handle] = p; });
        var missing = [];
        INKS.forEach(function (k) {
          if (map[k.handle]) fromCollectionJson(k, map[k.handle]);
          else missing.push(k);
        });
        // per-handle fallback for anything outside the source collection (e.g. Black Label)
        return Promise.all(missing.map(function (k) {
          return fetch('/products/' + k.handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { if (p) fromProductJs(k, p); })
            .catch(function () {});
        }));
      })
      .catch(function () {});
  }

  /* ---- state ---- */
  var toneIdx = 0, qty = {}, active = {};
  function seedActive() {
    INKS.forEach(function (k) {
      if (!k.variants || !k.variants.length) return;
      var sellable = k.variants.filter(function (v) { return v.available; });
      var pool = sellable.length ? sellable : k.variants;
      var one = pool.filter(function (v) { return v.title === '1 Oz'; })[0];
      active[k.handle] = (one || pool[0]).title;
    });
  }
  function vv(k, title) {
    if (!k.variants || !k.variants.length) return { price: null, title: '', id: 0 };
    return k.variants.filter(function (v) { return v.title === title; })[0] || k.variants[0];
  }
  var vkey = function (h, s) { return h + '|' + s; };

  /* ---- CSS (scoped .itf — .chip carries an explicit display:block to defeat
         the theme-global .chip{display:none} rule that once blanked every swatch) ---- */
  var css = document.createElement('style');
  css.textContent = [
    '.itf{--acc:#DB0A6B;--ink:#17151A;--muted:#6B7280;--line:#E6E6EA;--ls:#D2D3D9;--panel:#F5F5F7;--succ:#0A7D4B;--succbg:#EAFAF2;--blue:#1B57C4;--warn:#B25E00;--warnbg:#FBF0E2;--skin:#F4ECE0;font-family:Inter,system-ui,sans-serif;color:var(--ink);padding-bottom:88px}',
    '.itf *{box-sizing:border-box}',
    '.itf .tonebar{display:flex;gap:8px;overflow-x:auto;padding-bottom:4px;margin:6px 0 12px}',
    '.itf .lab{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.03em;color:var(--muted);white-space:nowrap;align-self:center}',
    '.itf .tchip{flex:0 0 auto;display:flex;align-items:center;gap:7px;border:1.5px solid var(--line);background:#fff;border-radius:999px;padding:4px 11px 4px 5px;cursor:pointer}',
    '.itf .tchip[aria-checked="true"]{border-color:var(--ink)}',
    '.itf .tchip .sw{width:20px;height:20px;border-radius:999px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12)}',
    '.itf .tchip .tn{font-size:12px;font-weight:700;line-height:1}.itf .tchip .tf{font-size:9px;font-weight:800;color:var(--blue);line-height:1;margin-top:1px}.itf .tchip .tx{display:flex;flex-direction:column}',
    '.itf .why{font-size:12.5px;color:var(--muted);margin:0 0 12px;display:flex;gap:8px}',
    '.itf .honest{background:var(--succbg);border:1px solid #BFE9D4;border-radius:10px;padding:9px 12px;font-size:12.5px;color:#0a5c39;margin:0 0 10px}',
    '.itf .cnt{font-size:12px;color:var(--muted);margin:0 0 14px}',
    '.itf .grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(158px,1fr));gap:14px}',
    '.itf .card{background:#fff;border:1px solid var(--line);border-radius:12px;padding:11px;box-shadow:0 1px 2px rgba(20,20,25,.06);display:flex;flex-direction:column;gap:9px;position:relative}',
    '.itf .card.added{box-shadow:0 0 0 1.5px var(--acc),0 6px 18px rgba(20,20,25,.10)}',
    '.itf .card.top::after{content:"TOP PICK";position:absolute;top:9px;right:9px;font-size:9px;font-weight:800;letter-spacing:.06em;color:#fff;background:var(--acc);padding:3px 7px;border-radius:999px}',
    '.itf .cw{position:relative;width:100%;height:96px;border-radius:10px;overflow:hidden;background:var(--skin);display:grid;place-items:center}',
    '.itf .chip{display:block;width:70%;height:70%;border-radius:9px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.10),0 1px 4px rgba(0,0,0,.14)}',
    '.itf .chip.op{box-shadow:inset 0 0 0 1px var(--ls),0 1px 4px rgba(0,0,0,.16)}',
    '.itf .nm{font-weight:700;font-size:13.5px;line-height:1.2}',
    '.itf .meta{display:flex;align-items:center;justify-content:space-between;gap:6px}',
    '.itf .price{font-weight:800;font-size:15px}',
    '.itf .op{font-size:9.5px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;padding:2px 6px;border-radius:999px;white-space:nowrap}',
    '.itf .op.hold{color:var(--succ);background:var(--succbg)}.itf .op.mute{color:var(--blue);background:#EAF1FC}.itf .op.ashy{color:var(--warn);background:var(--warnbg)}',
    '.itf .pills{display:flex;flex-wrap:wrap;gap:4px}',
    '.itf .pill{position:relative;border:1.5px solid var(--ls);background:#fff;color:var(--ink);font-weight:700;font-size:11px;padding:4px 7px;border-radius:8px;cursor:pointer;min-height:30px}',
    '.itf .pill[aria-pressed="true"]{border-color:var(--ink);background:var(--ink);color:#fff}',
    '.itf .pill .qb{position:absolute;top:-5px;right:-5px;min-width:15px;height:15px;border-radius:999px;background:var(--acc);color:#fff;font-size:9px;font-weight:800;display:grid;place-items:center;padding:0 3px}',
    '.itf .stp{display:flex;align-items:center;border:1px solid var(--ls);border-radius:10px;overflow:hidden;margin-top:auto}',
    '.itf .stp button{flex:0 0 40px;height:40px;border:0;background:var(--panel);font-size:20px;font-weight:700;cursor:pointer;color:var(--ink)}.itf .stp .v{flex:1;text-align:center;font-weight:800;font-size:14px}',
    '.itf .stp[hidden]{display:none}',
    '.itf .bar{position:fixed;left:0;right:0;bottom:0;z-index:40;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);border-top:1px solid var(--line);box-shadow:0 -6px 24px rgba(20,20,25,.12)}',
    '.itf .barin{max-width:1120px;margin:0 auto;padding:11px 16px;display:flex;align-items:center;gap:14px}',
    '.itf .ship{flex:1;min-width:0}.itf .st{font-size:12.5px;font-weight:600;color:#3F4147;margin-bottom:6px}.itf .st b{color:var(--succ)}',
    '.itf .track{height:7px;background:var(--panel);border-radius:999px;overflow:hidden}.itf .track>i{display:block;height:100%;width:0;background:var(--succ);border-radius:999px;transition:width .26s}',
    '.itf .tot{text-align:right}.itf .tot .n{font-weight:800;font-size:19px;line-height:1}.itf .tot .c{font-size:11px;color:var(--muted)}',
    '.itf .co{border:0;background:var(--acc);color:#fff;font-weight:800;font-size:14px;padding:12px 18px;border-radius:10px;cursor:pointer}.itf .co:disabled{opacity:.4}',
    '@media(prefers-reduced-motion:reduce){.itf *{transition:none!important}}'
  ].join('');
  document.head.appendChild(css);

  /* ---- DOM ---- */
  mount.className = 'itf';
  mount.innerHTML =
    '<div class="tonebar" role="radiogroup" aria-label="Client skin tone" id="itf-tones"></div>' +
    '<div class="honest" id="itf-honest"></div>' +
    '<p class="cnt" id="itf-cntline"></p>' +
    '<p class="why" id="itf-why"></p>' +
    '<div class="grid" id="itf-grid"></div>' +
    '<div class="bar"><div class="barin">' +
      '<div class="ship"><div class="st" id="itf-st" aria-live="polite"></div><div class="track"><i id="itf-track"></i></div></div>' +
      '<div class="tot"><div class="n" id="itf-tot">$0.00</div><div class="c" id="itf-cnt">0 inks</div></div>' +
      '<button class="co" id="itf-co" disabled>Add palette</button>' +
    '</div></div>';

  var tonesEl = document.getElementById('itf-tones');
  TONES.forEach(function (t, i) {
    var b = document.createElement('button');
    b.className = 'tchip'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
    b.setAttribute('aria-label', t.fst ? (t.name + ', Fitzpatrick ' + t.fst) : t.name);
    b.innerHTML = '<span class="sw" style="background:' + t.skin + '"></span><span class="tx"><span class="tn">' + t.name + '</span>' + (t.fst ? '<span class="tf">Type ' + t.fst + '</span>' : '') + '</span>';
    b.addEventListener('click', function () {
      toneIdx = i;
      Array.prototype.forEach.call(tonesEl.querySelectorAll('.tchip'), function (el, idx) {
        el.setAttribute('aria-checked', idx === i ? 'true' : 'false');
      });
      render();
    });
    if (i === 0) { var l = document.createElement('span'); l.className = 'lab'; l.textContent = 'Client tone'; tonesEl.appendChild(l); }
    tonesEl.appendChild(b);
  });

  function opTag(k, t) {
    var wl = wloss(k.opacity, k.hex, t);
    if (wl > 0.03) return '<span class="op ashy">Ashy ' + Math.round(wl * 100) + '%↓</span>';
    if (t.depth > 0.35) return k.opacity >= 0.6 ? '<span class="op hold">Holds</span>' : '<span class="op mute">Mutes</span>';
    return '<span class="op ' + (k.opacity > 0.9 ? 'hold' : 'mute') + '">' + (k.opacity > 0.9 ? 'Opaque' : 'Translucent') + '</span>';
  }

  var grid = document.getElementById('itf-grid');
  function render() {
    var t = TONES[toneIdx];
    mount.style.setProperty('--skin', t.skin);
    document.getElementById('itf-honest').innerHTML = t.key === 'none'
      ? '<b>Base pigment</b> — the colour before any skin. Pick a tone to see it through the skin veil.'
      : '<b>' + t.name + ' · Fitzpatrick ' + t.fst + '.</b> You are seeing the pigment through the skin — translucent inks mute on deeper tones, opaque colours hold, white reads ashy.';
    document.getElementById('itf-cntline').textContent =
      INKS.length + ' colours · swatches are a screen approximation of healed colour, not a colour-match guarantee.';
    document.getElementById('itf-why').textContent = t.key === 'none'
      ? 'Colour-wheel order. Pick a tone to re-rank by what survives the veil.'
      : 'Ranked by real-world performance through ' + t.name + ' skin.';

    var ranked = t.key === 'none'
      ? INKS.map(function (k) { return { k: k }; })                       // keep wheel order
      : INKS.map(function (k) { return { k: k, p: perf(k, t) }; })
            .sort(function (a, b) { return b.p - a.p; });

    grid.innerHTML = '';
    ranked.forEach(function (row, idx) {
      var k = row.k, isOp = k.opacity > 0.9;
      var ready = !!(k.variants && k.variants.length);
      var a = active[k.handle];
      var inCart = ready && k.variants.some(function (v) { return qty[vkey(k.handle, v.title)] > 0; });
      var q = qty[vkey(k.handle, a)] || 0;
      var pills = (ready && k.variants.length > 1) ? '<div class="pills">' + k.variants.map(function (v) {
        var sq = qty[vkey(k.handle, v.title)] || 0;
        return '<button class="pill" data-h="' + k.handle + '" data-s="' + v.title + '" aria-pressed="' + (v.title === a) + '" aria-label="' + k.name + ' ' + v.title + '">' + v.title.replace('1/2', '½').replace(' Oz', 'oz') + (sq > 0 ? '<span class="qb">' + sq + '</span>' : '') + '</button>';
      }).join('') + '</div>' : '';
      var card = document.createElement('div');
      card.className = 'card' + (inCart ? ' added' : '') + (idx === 0 && t.depth > 0 ? ' top' : '');
      card.innerHTML =
        '<a href="' + k.url + '" style="text-decoration:none;color:inherit">' +
          '<div class="cw"><div class="chip ' + (isOp ? 'op' : '') + '" style="background:' + observed(k.hex, k.opacity, t) + '"></div></div>' +
          '<div class="nm">' + k.name + '</div>' +
        '</a>' +
        '<div class="meta"><span class="price">' + money(ready ? vv(k, a).price : null) + '</span>' + opTag(k, t) + '</div>' +
        pills +
        '<div class="stp" data-h="' + k.handle + '"' + (ready ? '' : ' hidden') + '><button data-d="-1" aria-label="Remove one ' + k.name + '">−</button><span class="v">' + q + '</span><button data-d="1" aria-label="Add one ' + k.name + '">+</button></div>';
      grid.appendChild(card);
    });
  }

  grid.addEventListener('click', function (e) {
    var pill = e.target.closest('.pill');
    if (pill) { e.preventDefault(); active[pill.getAttribute('data-h')] = pill.getAttribute('data-s'); render(); return; }
    var btn = e.target.closest('.stp button[data-d]'); if (!btn) return;
    e.preventDefault();
    var h = btn.parentElement.getAttribute('data-h'), d = parseInt(btn.getAttribute('data-d'), 10), s = active[h];
    if (!s) return;
    var key = vkey(h, s); qty[key] = Math.max(0, (qty[key] || 0) + d);
    render(); updateBar();
  });

  function updateBar() {
    var total = 0, count = 0;
    INKS.forEach(function (k) {
      (k.variants || []).forEach(function (v) {
        var q = qty[vkey(k.handle, v.title)] || 0; total += q * v.price; count += q;
      });
    });
    document.getElementById('itf-tot').textContent = money(total);
    document.getElementById('itf-cnt').textContent = count + (count === 1 ? ' ink' : ' inks');
    document.getElementById('itf-track').style.width = Math.min(100, total / SHIP_GOAL * 100) + '%';
    document.getElementById('itf-st').innerHTML = total >= SHIP_GOAL
      ? '<b>✓ Free shipping unlocked</b>'
      : (total > 0 ? 'Add <b>' + money(SHIP_GOAL - total) + '</b> more for free shipping' : 'Orders $' + SHIP_GOAL + '+ ship free');
    var co = document.getElementById('itf-co');
    co.disabled = count === 0;
    co.textContent = count === 0 ? 'Add palette' : 'Add palette · ' + count;
  }

  document.getElementById('itf-co').addEventListener('click', function () {
    var items = [];
    INKS.forEach(function (k) {
      (k.variants || []).forEach(function (v) {
        var q = qty[vkey(k.handle, v.title)] || 0;
        if (q > 0 && v.id) items.push({ id: Number(v.id), quantity: q });
      });
    });
    if (!items.length) return;
    var co = this;
    co.disabled = true; co.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'add failed');
        co.textContent = 'Added ✓'; refreshCart(res);
        setTimeout(function () { qty = {}; render(); updateBar(); }, 1400);
      })
      .catch(function () { co.disabled = false; co.textContent = 'Add palette'; });
  });

  function refreshCart(res) {
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skin-tone-finder' });
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }
    } catch (e) { /* the item is in the cart regardless; fail quiet */ }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // paint the swatches straight away, then fill in prices when the network returns
  render(); updateBar();
  resolveVariants().then(function () { seedActive(); render(); updateBar(); });
})();
